import React from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import landUrl from '../resource/land.svg';
import { Fab, Typography, Grid, Hidden, useMediaQuery, Box, IconButton } from '@material-ui/core';
import logohome from '../resource/logo-home.svg';
import { Link } from 'react-scroll';
import { motion } from "framer-motion";

const useStyles = makeStyles((theme) => ({

    section: {
        height: '100vh',
        backgroundImage: `url(${landUrl})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'

    },
    columnDummys: {
        height: '100vh'
    },
    centerDummy: {
        height: '8em',
        [theme.breakpoints.down('xs')]: {
            height: '5em'
        },
    },
    logo: {
        height: '7em'
    },
    text: {


        color: 'white',

        fontSize: '5rem',

        [theme.breakpoints.down('lg')]: {
            fontSize: '4rem'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '3rem'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: 'rem'
        }
    }

}));

const bounceTransition = {
    y: {
        duration: 1,
        yoyo: 3,
        ease: "easeIn",
    },
    backgroundColor: {
        duration: 0,
        yoyo: 3,
        ease: "easeOut",
        repeatDelay: 1,
    },
};

const Down = (props) => (<motion.div {...props}></motion.div>);

const Home = () => {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Grid container direction="column" className={classes.section} >
            <Grid item xs />
            <Grid item container direction="column" alignItems="center">

                {
                    matchesSM &&
                    <Grid item style={{ marginBottom: '3em' }}>
                        <img className={classes.logo} src={logohome} alt="logo_home"></img>
                    </Grid>
                }

                <Grid item>
                    <Typography variant={matchesSM ? "h6" : "h2"} style={{ maxWidth: '20em' }}>
                        <Box fontWeight={750} align="center" color="white">
                            Plataformas de software sólidas, simples y seguras para tus desafíos de crecimiento.</Box>
                    </Typography>
                </Grid>

            </Grid>
            <Grid item xs container direction="column" justify="flex-end" >

                <Grid item align="center" style={{ marginBottom: '3em' }}>


                    <Down transition={bounceTransition}
                        animate={{
                            y: ["0em", "4em"],
                            //backgroundColor: ["#9b59b6", "#f1c40f"],
                        }}
                    >
                        <Link style={{ cursor: 'pointer' }} to="middleware_main" spy={true} smooth={true} duration={1000} delay={300}>
                            <IconButton
                                color="secondary"
                                disableFocusRipple
                                disableRipple>

                            </IconButton>
                        </Link>
                    </Down>
                </Grid>

            </Grid>
        </Grid >
    );
};

export default Home;